export default "__VITE_ASSET__354b1b64__"